<h3>{{data.head}}</h3>
<hr>

<div *ngIf="extension == 'mp4'" style="text-align: center;">
    <video width="600" height="240" controls>
        <source [src]="data.fileUrls?.url" type="video/mp4">
        <source [src]="data.fileUrls?.url" type="video/ogg">
        Your browser does not support the video tag.
    </video>
</div>

<ngx-doc-viewer *ngIf="extension != 'mp4'" [url]="data.fileUrls?.url" viewer="google" googleCheckContentLoaded="true"
    googleCheckInterval=1000 googleMaxChecks=5 style="width:100%;height:70vh;">
</ngx-doc-viewer>


<button mat-icon-button (click)="onNoClick()">
    <mat-icon>close</mat-icon>
</button>